import React from 'react'
import {useDropzone} from 'react-dropzone'
import Button from 'components/Button'
import dragnDrop from '../assets/drag-drop.svg'
import i18n from 'i18n'
import {BlobUpload, Optional} from 'data/types'

type DropzoneProps = {
  onDrop: (files: File[]) => void
  accept: string | string[]
  blob: Optional<BlobUpload>
  dragRejectText: string
  dragAcceptText: string
  releaseToDropText: string
  children: (blob: BlobUpload) => React.ReactNode
}

function Dropzone(props: DropzoneProps) {
  // Initializing useDropzone hooks with options
  const {getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject} = useDropzone({
    onDrop: (files) => {
      props.onDrop(files)
    },
    accept: props.accept,
  })

  /*
    useDropzone hooks exposes two functions called getRootProps and getInputProps
    and also exposes isDragActive boolean
  */

  return (
    <div
      className={`
      w-full h-1/5 items-center p-2 border rounded-md border-itx-border border-dashed bg-white outline-none
      ${isDragAccept ? 'border-green-400' : ''}
    `}
    >
      <div {...getRootProps()}>
        <input {...getInputProps()} multiple={false} />

        {props.blob ? (
          props.children(props.blob)
        ) : (
          <div className="flex flex-col items-center p-4">
            <img className={`w-14 h-14 pb-4`} alt={'dragnDrop'} src={dragnDrop} />

            {(() => {
              if (isDragActive) {
                return isDragReject ? (
                  <p className="text-base font-semibold text-red-500">{props.dragRejectText}</p>
                ) : (
                  <p className="text-base font-semibold text-green-400">{props.dragAcceptText}</p>
                )
              }

              return <p className="text-base font-semibold text-itx-primary-darkest">{props.releaseToDropText}</p>
            })()}

            <Button className="py-2 mt-4 bg-itx-primary-4 hover:bg-itx-primary-3 text-white" content={i18n.t('submitProblemView.browseToUpload')} />
          </div>
        )}
      </div>
    </div>
  )
}

export default Dropzone
